import { DateTime } from "luxon";

const DateConvertToShow = (currentDate, currentLanguage, timeZone) => {
    const langs = ["en","ru","uk","ar","cs","hi","id","th","vi"];
    const pickLang =
        langs.find(l => (currentLanguage || "").toLowerCase().includes(l)) || "en";

    let dt;
    if (currentDate == null) {
        dt = DateTime.now().setZone(timeZone);
    } else if (DateTime.isDateTime(currentDate)) {
        dt = currentDate.setZone(timeZone);
    } else if (currentDate instanceof Date) {
        dt = DateTime.fromJSDate(currentDate).setZone(timeZone);
    } else {
        dt = DateTime.fromISO(String(currentDate), { setZone: true }).setZone(timeZone);
    }

    return dt.setLocale(pickLang).toFormat("dd.MM.yyyy, EEEE");
};

export default DateConvertToShow;
